export * from './ie-policy.component';
